module.exports = __webpack_public_path__ + "static/media/sidebar-logo.f85df987.svg";